import React from 'react';
import NotFound from '../NotFound/NotFound';

const Offers = () => {
    return (
        <div>
            <NotFound />
        </div>
    );
};

export default Offers;